export default "__VITE_ASSET__CXUIMAmL__"